/**
 * Copies the provided text to the navigator clipboard.
 *
 * @async
 * @function
 * @param {string} text - The text to be copied to the clipboard.
 * @throws {Error} If the navigator object is undefined.
 * @returns {Promise} A promise that resolves when the text has been successfully copied to the clipboard.
 */
async function copyToClipboard(text) {
    if (typeof navigator === 'undefined') {
        throw new Error('[copyToClipboard.js] Trying to copy to clipboard when navigator is undefined');
    }

    // fun fact: Chrome does not include clipboard in navigator object unless the site is secure
    // You may override that by going to chrome://flags/#Insecure-origins-treated-as-secure, enabling it,
    // and including any allowed URLs, including their port
    // As of this writing, there’s no setting to allow this for Firefox.
    await navigator?.clipboard.writeText(text);
}

export default copyToClipboard;
